import { render } from "./submenu.vue?vue&type=template&id=60f7a10d"
import script from "./submenu.vue?vue&type=script&lang=js"
export * from "./submenu.vue?vue&type=script&lang=js"
script.render = render

export default script